import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useFetchPolicy,
  usePolicyManagementFine,
  usePolicyManagementPolicy,
  useSetPolicyFine,
} from '../../../store/PolicyManagement/policyManagementHooks';
import QuestionModal from '../../shared/QuestionModal/QuestionModal';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';
import { calculatePolicyFine } from '../../../utility/services/policy-calculate';
import { SubscriptionManagement } from '../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

const DidGymTourModal = () => {
  const { t } = useTranslation();

  return (
    <QuestionModal
      title={t('HAVE_YOU_DONE_GYM_TOUR_BEFORE')}
      subTitle={''}
      confirmButtonText={t('YES_I_DID')}
      cancelButtonText={t('NO_I_DIDNT')}
    />
  );
};

export default DidGymTourModal;
